import { render, staticRenderFns } from "./OperationLogs.vue?vue&type=template&id=36f75fef&scoped=true"
import script from "./OperationLogs.vue?vue&type=script&lang=js"
export * from "./OperationLogs.vue?vue&type=script&lang=js"
import style0 from "./OperationLogs.vue?vue&type=style&index=0&id=36f75fef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f75fef",
  null
  
)

export default component.exports